import PersonalizationCardImage from "./components/PersonalizationCardImage";
import PersonalizationInput from "./components/PersonalizationInput";
import PersonalizationTextarea from "./components/PersonalizationTextarea";
import PersonalizationDivider from "./components/PersonalizationDivider";
import Dropdown from "../../../Admin Panel/Dropdown/Dropdown";
import React from "react";

export default function PersonalizationHealthConcernsIntro({getError,surveySettingsFormData,setSurveySettingsFormData,healthConcernsFormData,setHealthConcernsFormData}) {
    const scaleDesignOptions = [
        {
            name:(
                <span style={{display:"inline-flex", alignItems:"center", gap:"4px"}}>
                    <img src={"/assets/ic_like.svg"} alt={"Best"} style={{width:"12px", height:"12px"}} />
                    <span>Best (Low Scale)</span>
                    <span>&rarr;</span>
                    <img src={"/assets/ic_dislike.svg"} alt={"Worst"} style={{width:"12px", height:"12px"}} />
                    <span>Worst (High Scale)</span>
                </span>
            ),
            value:'green_to_red'
        },
        {
            name:(
                <span style={{display:"inline-flex", alignItems:"center", gap:"4px"}}>
                    <img src={"/assets/ic_dislike.svg"} alt={"Worst"} style={{width:"12px", height:"12px"}} />
                    <span>Worst (Low Scale)</span>
                    <span>&rarr;</span>
                    <img src={"/assets/ic_like.svg"} alt={"Best"} style={{width:"12px", height:"12px"}} />
                    <span>Best (High Scale)</span>
                </span>
            ),
            value:'red_to_green'
        },
    ];

    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap:'20px'
    }}>
        <PersonalizationCardImage src={'/assets/survey_personalization_screens/top_3_1.png'} alt={'Welcome Screen'} />

        <PersonalizationInput
            title={'Section Title'}
            value={healthConcernsFormData?.title}
            setValue={(value) => setHealthConcernsFormData({title:value})}
            errorMessage={getError('healthConcerns','title')}
        />

        <PersonalizationTextarea
            title={'Description'}
            value={healthConcernsFormData?.desc}
            setValue={(value) => setHealthConcernsFormData({desc:value})}
            errorMessage={getError('healthConcerns','desc')}
        />

        <PersonalizationInput
            title={'Video Link (Optional)'}
            value={healthConcernsFormData?.videoUrl}
            setValue={(value) => setHealthConcernsFormData({videoUrl:value})}
            errorMessage={getError('healthConcerns','videoUrl')}
        />

        <PersonalizationDivider/>


        <Dropdown
            label={"Scale Direction"}
            placeholder={"Scale Direction"}
            type={"scaleDesign"}
            setSelectedOption={(option) => {
                setSurveySettingsFormData({healthConcernScaleDesign:option?.value})
            }}
            selectedOption={surveySettingsFormData?.healthConcernScaleDesign}
            options={scaleDesignOptions}
        />

        <PersonalizationDivider/>

        <PersonalizationCardImage src={'/assets/survey_personalization_screens/top_3_2.png'} alt={'Welcome Screen'} />

        <PersonalizationInput
            title={'Section Title on PDF'}
            value={healthConcernsFormData?.pdfTitle}
            setValue={(value) => setHealthConcernsFormData({pdfTitle:value})}
            errorMessage={getError('healthConcerns','pdfTitle')}
        />

    </div>
}
